import { ActionBrick, Query, registerBrick, Transaction } from 'olympe';
import { getLogger } from '@olympeio/core';
import BCP from '../../../common/section_bcp/DM_BCP';

export default class UpdateRequestIdForBCPs extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    async update($, [], [forwardEvent]) {
        this.logger = getLogger('UpdateRequestIdToExistingBCPs');
        // 1. Fetch BCP requests with either of the states to migrate
        const bcpRequests = (await Query.instancesOf(BCP).andReturn().execute()).toArray();
        this.logger.log(`BCP requests + ${bcpRequests}`);
        const tx = new Transaction();
        for (const bcpRequest of bcpRequests) {
            this.logger.log("current BCP request ", bcpRequest.getPlantId() + bcpRequest.getMaterialId())
            let requestId = bcpRequest.getPlantId() + bcpRequest.getMaterialId()
            BCP.setRequestId(tx, bcpRequest, requestId)
            this.logger.log("After completing the update", bcpRequest.getPlantId(), bcpRequest.getMaterialId())
            // We will find all the BCP request which does not have requestId and then update the request Id
        }
        await tx.execute();
        // Trigger the output Control Flow
        forwardEvent();
    }
}

registerBrick('019560d8398145d768a7', UpdateRequestIdForBCPs);
